/**
 * 班级/在班状态标签（class-management 前端共享小组件）。
 */
import { Tag } from 'antd';
import type { ClassStatus, EnrollmentStatus } from '../../api/classes.api';

/** 班级五态标签映射（对齐原型 ClassStatusTag）。 */
const classStatusTag: Record<ClassStatus, { color: string; label: string }> = {
  DRAFT: { color: 'default', label: '草稿' },
  RECRUITING: { color: 'blue', label: '招生中' },
  ACTIVE: { color: 'green', label: '进行中' },
  COMPLETED: { color: 'orange', label: '已结课' },
  ARCHIVED: { color: 'default', label: '已归档' },
};

export function ClassStatusTag({ status }: { status: ClassStatus }) {
  const conf = classStatusTag[status];
  return <Tag color={conf.color}>{conf.label}</Tag>;
}

/** 在班状态标签。 */
export function EnrollmentStatusTag({ status }: { status: EnrollmentStatus }) {
  return status === 'ACTIVE' ? (
    <Tag color="green">在班</Tag>
  ) : (
    <Tag>已离班</Tag>
  );
}
